module.exports = __webpack_public_path__ + "43a5d75fed8c44337e65823d74119525.png";